import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { UserDto } from '@workspace/data-types';
import { LuxonDatePipe } from '@workspace/ng-aura';

@Component({
  selector: 'etxe-property-seller-info',
  standalone: true,
  imports: [CommonModule, MatIconModule, LuxonDatePipe],
  templateUrl: './property-seller-info.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block' },
})
export class EtxePropertySellerInfoComponent {
  owner = input.required<UserDto>();
  isOwner = input<boolean>(false);
}
